
























import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Toast } from "vant";
import listCom from "@/components/estate/listCom.vue";
const estateModule = namespace("estate");

@Component({
  components: { listCom }
})
export default class List extends Vue {
  activeStatus: number = 10;
  finished: boolean = false;
  loading: boolean = false;
  list: any = [];
  pages: any = {
    pageNum: 1,
    pageSize: 10,
    totalPage: 0
  };

  mounted() {}
  handleActiveChange(val: any) {
    this.activeStatus = val;
    this.pages.pageNum = 1;
    this.list = [];
    this.getData();
  }
  getData() {
    this.loading = true;
    this.finished = false;
    if (this.pages.total > 0 && this.pages.total === this.list.length) {
      this.finished = true;
    }
    this.$store
      .dispatch("estate/getEstateList", {
        pageNum: this.pages.pageNum,
        pageSize: this.pages.pageSize,
        status: this.activeStatus
      })
      .then(res => {
        this.loading = false;
        if (res.success) {
          this.pages.totalPage = res.success.data.pages;
          if (!res.success.data.list) {
            this.finished = true;
            return;
          }
          this.list = [...this.list, ...res.success.data.list];
          this.list.map((item: any) => {
            item.petitionTime = this.$format(
              item.petitionTime,
              "YYYY.MM.DD HH:mm:ss"
            );
          });
          this.pages.pageNum++;
          if (this.pages.pageNum > this.pages.totalPage) {
            this.finished = true;
          }
          console.log(this.list);
        } else {
          this.finished = true;
        }
      });
  }

  onLoadList() {
    let self = this;
    setTimeout(() => {
      self.getData();
    }, 1000);
  }
  handleDetailClick(item: any) {
    console.log(item);
    this.$router.push({
      path: "/estateWorker/info",
      query: { id: item.id }
    });
  }
}
